import { NavLink } from "react-router-dom";
import { Home as HomeIcon, Users, Clock, User as UserIcon } from "lucide-react";

const tabs = [
  { to: "/home", label: "Accueil", Icon: HomeIcon, testId: "nav-home" },
  { to: "/dashboard", label: "Équipe", Icon: Users, testId: "nav-dashboard" },
  { to: "/history", label: "Historique", Icon: Clock, testId: "nav-history" },
  { to: "/profile", label: "Profil", Icon: UserIcon, testId: "nav-profile" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-30 border-t border-slate-200 bg-white/95 backdrop-blur-md"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="mx-auto flex max-w-xl items-stretch justify-around px-2">
        {tabs.map(({ to, label, Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-semibold transition-colors ${
                isActive
                  ? "text-[var(--sa-blue)]"
                  : "text-slate-400 hover:text-slate-700"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={`flex h-7 w-12 items-center justify-center rounded-full transition-all ${
                    isActive ? "bg-[var(--sa-blue-soft)]" : ""
                  }`}
                >
                  <Icon size={18} strokeWidth={2.2} />
                </span>
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
